module.exports = __webpack_public_path__ + "static/will-f0504d2ee9365cdca00b407c8e0f3e08.png";